import React from 'react';
import './App.scss';
import { Content } from 'carbon-components-react/lib/components/UIShell';
import EditorHeader from './components/EditorHeader';
import { Route, Switch } from 'react-router-dom';
import EditorPage from './content/EditorPage';

function App() {
  return (
	  <>
	    <EditorHeader />
	    <Content>
		  <Switch>
			<Route exact path="/" component={EditorPage} />
		  </Switch>
	    </Content>
	  </>
  );
}

export default App;
